import { useState } from "react";
import { useTranslation } from "react-i18next";

const faqItems = ["q1", "q2", "q3", "q4"];

export default function FaqSection() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full scroll-mt-24 bg-background-100/70 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[760px] px-4 md:px-6">
        <h2 className="text-center font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
          {t("faq.title")}
        </h2>

        <div className="mt-8 space-y-3">
          {faqItems.map((key, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={key}
                className="overflow-hidden rounded-lg border border-foreground-200/70 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-semibold text-foreground-900 md:text-base">
                    {t(`faq.${key}`)}
                  </span>
                  <span className="flex w-6 h-6 shrink-0 items-center justify-center">
                    <i
                      className={`${
                        isOpen ? "ri-subtract-line" : "ri-add-line"
                      } text-lg text-foreground-500`}
                    ></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="border-t border-foreground-200/70 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-600">
                      {t(`faq.${key.replace("q", "a")}`)}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}